import { createSelector } from "reselect";

export const isLoadingMalfunctions = (state) =>
  state.malfunction?.loadingMalfunctions;
export const isLoadingMalfunctionsCategories = (state) =>
  state.malfunction?.loadingMalfunctionsCategories;

export const selectMalfunctions = (state) =>
  state.malfunction?.malfunctions || [];
export const selectVehicleNumber = (state) => state.malfunction?.vehicleNumber;
export const selectMalfunctionsCategories = (state) =>
  state.malfunction?.malfunctionsCategories || [];

export const selectIdentifier = (state, props) =>
  props?.match?.params?.identifier;

export const selectCategoryByIdentifier = createSelector(
  [(state, props) => props.identifier, selectMalfunctionsCategories],
  (categoryId, categories) => {
    if (!categories || categories.length === 0) return false;
    if (!categoryId) return undefined;
    return categories.find((category) => category.id === categoryId);
  },
);
